export const filterStyles = (theme) => ({
  select: {
    fontWeight: 'bold',
  },
  root: {
    paddingLeft: 8,
  },
});
